import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { filter } from 'lodash';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button, Modal, Popover, OverlayTrigger } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import SearchPath from '../../../../components/search-path';
import { fetchTvTagMappings, addTvTagMappings, deleteTvTagMappings } from '../../SetupActions';
import ProgressBar from '../../../../components/progress-bar';
import PathDisplay from '../../../../components/search-path/path';
import ConfirmButton from '../../../../components/confirm-button';
import ApplyTagModal from './ApplyTagModal';
import ResultModal from './ResultModal';
import styles from '../TruVoiceProductsPage/styles.css';


class TruVoiceTagsInnerPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      loaded: false,
      errors: null,
      fields: [],
      showModal: false,
      selectedField: null,
      submitting: false,
      currentField: null,
      viewCollector: null,
    };
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.filterNodes = this.filterNodes.bind(this);
    this.selectSearchPath = this.selectSearchPath.bind(this);
    this.addField = this.addField.bind(this);
    this.deleteField = this.deleteField.bind(this);
    this.applyTag = this.applyTag.bind(this);
    this.handleShowResults = this.handleShowResults.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  applyTag(currentField) {
    this.setState({ currentField });
  }

  showModal() {
    this.setState({ showModal: true, selectedField: null, submitting: false });
  }

  hideModal() {
    this.setState({ showModal: false, selectedField: null, submitting: false });
  }

  selectSearchPath(selectedField) {
    this.setState({ selectedField })
  }

  handleShowResults(viewCollector) {
    console.clear();
    console.log('viewCollector', viewCollector)
    this.setState({ viewCollector });
  }


  loadData() {
    this.setState({
      loading: true, loaded: false, errors: null, fields: [],
    });
    this.props.dispatch(fetchTvTagMappings(this.props.source))
      .then(
        ({ fields }) => {
          this.setState({
            loading: false,
            loaded: true,
            errors: null,
            fields,
            deleting: {}, // indexed by id
          });
        },
        (errors) => {
          this.setState({
            loading: false, loaded: false, errors: errors.data?.message || errors, fields: [],
          });
        },
      );
  }

  filterNodes(node) {
    const { fields } = node;
    return fields; // everything
  }

  addField() {
    this.setState({ submitting: true }, () => {
      const { selectedField } = this.state;
      this.props.dispatch(addTvTagMappings(this.props.source, selectedField))
        .then(
          (newField) => {
            const newFields = [...this.state.fields, newField];
            this.setState({
              fields: newFields,
            }, () => {
              this.hideModal();
            });
          },
          (errors) => {
            this.setState({
              submitting: false,
            }, () => {
              const message = errors.data?.message || errors.data;
              const el = (<div>{message}</div>);
              this.context.addNotification(el, { type: 'error', autoClose: true });
            });
          },
        );
    });
  }



  deleteField(field) {
    this.setState({ deleting: { ...this.state.deleting, [field._id]: true } }, () => {
      this.props.dispatch(deleteTvTagMappings(this.props.source, field._id))
        .then(
          (deletedField) => {
            const newFields = filter(this.state.fields, (f) => {
              return f._id !== field._id;
            });
            this.setState({
              fields: newFields,
              deleting: { ...this.state.deleting, [field._id]: false },
            });
          },
          (errors) => {
            this.setState({
              deleting: { ...this.state.deleting, [field._id]: false },
            }, () => {
              const message = errors.data?.message || errors.data;
              const el = (<div>{message}</div>);
              this.context.addNotification(el, { type: 'error', autoClose: true });
            });
          },
        );
    });
  }

  renderTable() {
    const { fields, deleting } = this.state;
    const { startingNode } = this.props;

    const popover = (
      <Popover id="apply-tags" className={styles.dropdownPopover}>
        <div style={{ padding: 10 }}>Apply tags to TruVoice</div>
      </Popover>
    );

    return (
      <div>
        <table className="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Field</th>
              <th width="120">Delete</th>
              <th width="110">Push</th>
            </tr>
          </thead>
          <tbody>
            {fields.map((field) => {
              const isDeleting = deleting[field._id] === true;
              return (
                <tr key={field._id}>
                  <td>
                    {!field.accessible && <span><Fa name="exclamation-triangle" className="text-danger" />&nbsp;</span>}
                    <PathDisplay
                      startingNode={startingNode}
                      paths={field.field}
                      skipMetaCheck={!field.accessible}
                    />
                    {!field.accessible && <span>&nbsp;<span className="label label-danger text-uppercase">inaccessible field</span></span>}
                  </td>
                  <td>
                    <ConfirmButton
                      size="xs"
                      disabled={isDeleting}
                      onConfirm={() => { this.deleteField(field); }}
                    >
                      <Fa name={isDeleting ? 'spinner' : 'trash'} spin={isDeleting} /> Delete
                    </ConfirmButton>

                  </td>
                  <td>
                    {field.accessible && 
                      <OverlayTrigger
                        trigger="hover"
                        placement="top"
                        overlay={popover}
                      >
                        <Button
                          bsSize="xs"
                          disabled={isDeleting}
                          bsStyle="primary"
                          onClick={() => { this.applyTag(field); }}
                        >
                          <Fa name="upload" /> Push Tag
                        </Button>
                      </OverlayTrigger>
                    }
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    );
  }


  renderAddButton() {
    return (
      <Button bsStyle="primary" onClick={this.showModal}><Fa name="plus" /> Add New {this.props.source} Tag Field</Button>
    )
  }


  renderModal() {
    const { startingNode } = this.props;
    const { showModal, selectedField, submitting } = this.state;
    const hasSelected = selectedField && selectedField.length > 0;

    return (
      <Modal show={showModal} onHide={this.hideModal}>
        <Modal.Header closeButton>
          <Modal.Title>Select a Field to use as {startingNode} Tag</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <SearchPath
              paths={selectedField}
              onUpdate={this.selectSearchPath}
              selectedSearchPaths={[]}
              disabled={submitting}
              filterNodes={this.filterNodes}
              controlLabel="Change"
              startingNode={startingNode}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <Button disabled={(submitting || !hasSelected)} className="pull-right" bsStyle="primary" onClick={this.addField}>Add Field</Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }


  render() {
    const { loading, loaded, errors, fields } = this.state;
    if (loading) {
      return (<ProgressBar />);
    }
    if (!loaded) {
      if (errors) {
        return (
          <div className="alert alert-danger">{errors}</div>
        );
      }
      return null;
    }

    return (
      <div>
        <div className="text-right">
          {this.renderAddButton()}
        </div>
        {this.renderModal()}
        <p />
        {fields.length > 0 && this.renderTable()}
        {fields.length > 0 &&
          <ApplyTagModal
            field={this.state.currentField}
            collectors={this.props.collectors}
            onClose={() => { this.setState({ currentField: null }); }}
            showResults={this.handleShowResults}
          />
        }
        <ResultModal
          collector={this.state.viewCollector}
          field={this.state.currentField}
          onHide={() => { this.setState({ viewCollector: null }); }}
        />
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state, props) {
  const { source } = props;
  let startingNode = 'Opportunity';
  if (source === 'account') {
    startingNode = 'Account';
  } else if (source === 'contact') {
    startingNode = 'Contact';
  }
  return {
    startingNode,
  };
}

TruVoiceTagsInnerPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  source: PropTypes.string.isRequired,
  startingNode: PropTypes.string.isRequired,
  collectors: PropTypes.arrayOf(PropTypes.shape({})),
};

TruVoiceTagsInnerPage.defaultProps = {
  collectors: [],
};

TruVoiceTagsInnerPage.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};


export default withRouter(connect(mapStateToProps)(TruVoiceTagsInnerPage));
